import { ButtonProps } from "../../../../types"
import Button from "../button"

const PrimaryBtn = ({ children, className = "", ...rest }: ButtonProps) => (
  <Button
    {...rest}
    className={`${className} border-transparent text-white bg-primary-400 hover:bg-primary-500 focus:ring-primary-300 disabled:bg-neutral-400`}
  >
    {children}
  </Button>
)

export default PrimaryBtn
